<template>
  <div class="pa-premium-summary">
    <p class="plan-line">{{ optionName }} · {{ durationLabel }}</p>
    <p v-if="coverPeriodLabel" class="cover-period-line">{{ coverPeriodLabel }}</p>
    <p class="premium-amount">KES {{ formattedPremium }}</p>
    <p v-if="mock" class="demo-tag">Demo pricing</p>
  </div>
</template>

<script>
export default {
  name: 'PaPremiumSummary',
  props: {
    optionName: { type: String, default: '' },
    durationLabel: { type: String, default: '' },
    premium: { type: Number, default: 0 },
    mock: { type: Boolean, default: true },
    coverStartDate: { type: String, default: '' },
    coverEndDate: { type: String, default: '' },
  },
  computed: {
    coverPeriodLabel() {
      if (!this.coverStartDate) return '';
      const start = this.formatDate(this.coverStartDate);
      const end = this.coverEndDate ? this.formatDate(this.coverEndDate) : '';
      return end ? `${start} → ${end}` : `From ${start}`;
    },
    formattedPremium() {
      return Number(this.premium || 0).toLocaleString('en-KE');
    },
  },
  methods: {
    formatDate(iso) {
      const [y, m, d] = String(iso).split('-');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${Number(d)} ${months[Number(m) - 1]} ${y}`;
    },
  },
};
</script>

<style scoped>
.pa-premium-summary { text-align: center; }
.plan-line { font-size: 0.8rem; color: rgba(255,255,255,0.75); margin: 0 0 4px; }
.cover-period-line { font-size: 0.72rem; color: rgba(255,255,255,0.6); margin: 0 0 6px; }
.premium-amount { font-size: 1.75rem; font-weight: 800; color: white; margin: 0; letter-spacing: -0.5px; }
.demo-tag {
  display: inline-block;
  margin-top: 10px;
  font-size: 0.62rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.55);
  background: transparent;
  padding: 0;
  border-radius: 0;
  letter-spacing: 0.02em;
}
</style>
